module.exports = __webpack_public_path__ + "static/media/280109.93b5f052.png";